import React from 'react'

const FollowingUser = (props) => (
    <svg width="15" height="16" viewBox="0 0 15 16" fill={props.color ? props.color : '#FFFFFF'}
         xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd"
              d="M10.1436 4.08442C10.1436 6.34018 8.327 8.16884 6.08614 8.16884C3.84529 8.16884 2.02871 6.34018 2.02871 4.08442C2.02871 1.82866 3.84529 0 6.08614 0C8.327 0 10.1436 1.82866 10.1436 4.08442ZM8.11486 4.08442C8.11486 5.2123 7.20657 6.12663 6.08614 6.12663C4.96571 6.12663 4.05743 5.2123 4.05743 4.08442C4.05743 2.95654 4.96571 2.04221 6.08614 2.04221C7.20657 2.04221 8.11486 2.95654 8.11486 4.08442Z"
              />
        <path d="M11.1089 13.6115L14 11L15 12.2178L11.1089 16L8.36408 13.2389L9.5 12L11.1089 13.6115Z" fill="white"/>
        <path
            d="M6.08614 9.18994C2.72486 9.18994 0 11.9329 0 15.3166H2.02871C2.02871 13.0608 3.84529 11.2321 6.08614 11.2321C6.70991 11.2321 7.3008 11.3738 7.82879 11.627V9.44478C7.27671 9.27898 6.69176 9.18994 6.08614 9.18994Z"
            />
    </svg>
)

export default FollowingUser
